import React, { useContext, useState, useMemo } from 'react'
import { Card, Row, Col, Button, Input, Table, Spin, Typography, Space } from 'antd'
import { UserAddOutlined, UploadOutlined, ReloadOutlined, DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { filterTableV2 } from '@/search'
import Breadcrumb from './Breadcrumb'
import { ManageSuppliersContext } from './ManageSuppliers'

export default function Suppliers({ loading }) {
    const {
        canCreate,
        canExport,
        canImport,
        suppliers,
        columns,
        selectedSuppliers,
        onOpenCreateForm,
        onReload,
        onOpenImport,
        onOpenExport,
        onChangeSelectedSuppliers
    } = useContext(ManageSuppliersContext)

    const [query, setQuery] = useState('')

    const onDebounceChangeQuery = _.debounce(value => setQuery(value), 200)

    const filterSuppliers = useMemo(() => filterTableV2(query, suppliers, ['code', 'name']), [query, suppliers])

    return (
        <React.Fragment>
            <Card title={<Typography.Title level={3}>Suppliers</Typography.Title>} extra={<Breadcrumb />}>
                <Row gutter={[0, 8]}>
                    <Col sm={24} md={24} lg={24} xl={12}>
                        <Space className="d-flex justify-content-between justify-content-xl-start align-items-center">
                            <Button
                                disabled={!canCreate}
                                type="primary"
                                icon={<UserAddOutlined />}
                                onClick={onOpenCreateForm}>
                                Create
                            </Button>
                            <Button disabled={!canImport} type="info" icon={<UploadOutlined />} onClick={onOpenImport}>
                                Import
                            </Button>
                            <Button
                                disabled={!canExport}
                                type="info"
                                icon={<DownloadOutlined />}
                                onClick={() => onOpenExport('SELECTED')}>
                                Export (<span>{selectedSuppliers.length}</span>)
                            </Button>
                            <Button
                                disabled={!canExport}
                                type="info"
                                icon={<DownloadOutlined />}
                                onClick={() => onOpenExport('ALL')}>
                                Export All
                            </Button>
                            <Button disabled={loading} icon={<ReloadOutlined />} onClick={onReload}>
                                Reload
                            </Button>
                        </Space>
                    </Col>
                    <Col sm={24} md={24} lg={24} xl={12}>
                        <div className="d-flex gap-2 justify-content-end align-items-center">
                            <Input
                                className="w-100"
                                allowClear
                                size="middle"
                                placeholder="Search"
                                prefix={<SearchOutlined />}
                                onChange={e => onDebounceChangeQuery(e.target.value)}
                            />
                        </div>
                    </Col>
                </Row>
                <br />
                <Spin spinning={loading}>
                    <Table
                        bordered
                        rowKey={record => record.id}
                        columns={columns}
                        dataSource={filterSuppliers}
                        scroll={{ x: 'max-content' }}
                        rowSelection={{
                            onChange: (_, rows) => onChangeSelectedSuppliers(rows)
                        }}
                    />
                </Spin>
            </Card>
        </React.Fragment>
    )
}
